import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1158f1fc")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "p-text-left box-header p-d-flex p-jc-between p-ai-center" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "p-col-4" }, "Comentarios")
], -1)
const _hoisted_2 = {
  key: 0,
  class: "p-grid comments-box"
}
const _hoisted_3 = { class: "p-grid" }
const _hoisted_4 = { class: "p-col-3 person-name" }
const _hoisted_5 = { class: "p-col-8 comments" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NPSComments = _resolveComponent("NPSComments")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_TabView, {
      class: "no-padding border-box",
      activeIndex: _ctx.activeIndex,
      "onUpdate:activeIndex": _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeIndex = $event))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabsTable, (tab) => {
          return (_openBlock(), _createBlock(_component_TabPanel, {
            key: tab.key,
            disabled: tab.disabled
          }, {
            header: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(tab.header), 1)
            ]),
            default: _withCtx(() => [
              true
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.NPSComments, (comment) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: comment._id,
                        class: "p-col-12"
                      }, [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("div", _hoisted_4, _toDisplayString(`${comment.infoUser.profile.firstName} ${comment.infoUser.profile.lastName}`), 1),
                          _createElementVNode("div", _hoisted_5, _toDisplayString(comment.npsFeedback.comments[0]), 1),
                          _createElementVNode("div", {
                            class: _normalizeClass(["p-col-1 rating", [comment.npsFeedback.score < 6 ? 'text-problem' : comment.npsFeedback.score < 9  ? 'text-regular': 'text-green-brain']])
                          }, _toDisplayString(comment.npsFeedback.score), 3)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              false
                ? (_openBlock(), _createBlock(_component_NPSComments, {
                    key: 1,
                    class: "border-box",
                    feedbacks: _ctx.personFeedbacks,
                    tableKey: tab.key,
                    commentsSummary: _ctx.commentsSummary
                  }, null, 8, ["feedbacks", "tableKey", "commentsSummary"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["disabled"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["activeIndex"])
  ], 64))
}